<script setup lang="ts" async>
useMenuState().value = 'collapsed';
</script>

<template>
  <NuxtLayout name="text-only">
    <PlanVisit class="!text-black !border-black" />
  </NuxtLayout>
</template>
